import ReportDataTable from "./ReportDataTable";

const formatDateTime = (value) => {
  if (!value) return "--------";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleString();
};

const stockWithUnit = (stock, unit) =>
  stock || stock === 0 ? `${stock} ${unit || ""}`.trim() : "--------";

const stockRangeWithUnit = (currentStock, originalStock, unit) =>
  `${stockWithUnit(currentStock, unit)} / ${stockWithUnit(originalStock, unit)}`;

const InventoryStatusReport = ({ rows = [], loading }) => {
  const columns = [
    { key: "serial", label: "S/N", render: (row) => row.serial },
    {
      key: "lastUpdated",
      label: "Last Updated",
      render: (row) => formatDateTime(row.lastUpdated),
    },
    { key: "itemName", label: "Item Name" },
    {
      key: "stock",
      label: "Stock (Current/Original)",
      render: (row) =>
        stockRangeWithUnit(row.currentStock, row.originalStock, row.unit),
    },
    // { key: "totalOrders", label: "Total Orders" },
    {
      key: "stockStatus",
      label: "Stock Status",
      render: (row) =>
        Number(row.currentStock) <= Number(row.threshold)
          ? "Low Stock"
          : "In Stock",
    },
  ];

  const reportRows = rows.map((row, index) => ({
    ...row,
    serial: index + 1,
  }));

  return (
    <ReportDataTable
      className="inventory-status-report"
      columns={columns}
      rows={reportRows}
      loading={loading}
      emptyMessage="No inventory status data found."
    />
  );
};

export default InventoryStatusReport;
